var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../BlocksElement';
import styles from './skeleton.styles';
/**
 * @slot default - displays light dom content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 * @csspart loader-text - The component's loader text.
 */
export class BlocksSkeleton extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         * aria-label property. To be used for accessibility
         */
        this.arialabel = 'loading';
        /**
         * The ARIA live region politeness level for the loader.
         *
         * @type {string}
         * @default "assertive"
         */
        this.arialive = 'assertive';
    }
    static { this.styles = styles; }
    updated(_changedProperties) {
        if (_changedProperties.has('width') && this.width) {
            this.style.setProperty('--cat-skeleton-loader-width', this.width);
        }
    }
    render() {
        const componentClassNames = this.componentClassNames('cat-c-skeleton', {
            'cat-c-skeleton--sm': this.size === 'sm',
            'cat-c-skeleton--lg': this.size === 'lg',
            'cat-c-skeleton--xl': this.size === 'xl',
            'cat-c-skeleton--xxl': this.size === 'xxl'
        });
        return html `
      <div part="base" aria-live=${this.arialive} class="${componentClassNames}" aria-label=${ifDefined(this.arialabel)} role="alert">
        <span part="loader-text" class="cat-c-skeleton__loader-text"> ${this.arialabel}</span>
        <slot part="part-default"></slot>
      </div>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksSkeleton.prototype, "size", void 0);
__decorate([
    property({ type: String })
], BlocksSkeleton.prototype, "width", void 0);
__decorate([
    property({ type: String })
], BlocksSkeleton.prototype, "arialabel", void 0);
__decorate([
    property({ type: String })
], BlocksSkeleton.prototype, "arialive", void 0);
if (customElements.get('cat-skeleton') === undefined) {
    customElements.define('cat-skeleton', BlocksSkeleton);
}
